import { Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { Table } from 'primeng/table'
import { AccountDto } from 'src/app/services/dtos'
import { UiService } from 'src/app/services/ui.service'

@Component({
  selector: 'arpio-accounts-list',
  templateUrl: './arpio-accounts-list.component.html',
  styleUrls: ['./arpio-accounts-list.component.scss'],
  standalone: false,
})
export class ArpioAccountsListComponent implements OnDestroy {
  @Input('accounts') accounts
  @ViewChild('filterInput') filterInput!: ElementRef
  @ViewChild('dt2') accListTable: Table

  productName = this.uiService?.productName
  scrollHeight: string
  isFilterApplied: boolean

  isCustomComponent$ = this.uiService.isCustomComponent$

  constructor(
    private uiService: UiService,
    private router: Router
  ) {
    this.adjustScrollHeight()
    this.uiService.isCustomComponent$.next(true)
  }

  ngAfterViewInit(): void {
    this.uiService.sortTable(this.accListTable, 'name', 1)
  }

  ngOnDestroy(): void {
    this.uiService.isCustomComponent$.next(false)
  }

  accountTrackBy(index: number, accounts: AccountDto) {
    return accounts.accountId
  }

  navigateToAccountWithID(accountID: string) {
    this.router.navigateByUrl(`/${accountID}`)
  }

  adjustScrollHeight() {
    // Example calculation (you might need to adjust this based on your layout)
    // Let's say you have a header of 347px height and a footer of 50px height that you want to exclude from the viewport height
    const headerFooterHeight = 347 + 50 // Example fixed height in pixels
    const viewportHeight = window.innerHeight // Viewport height in pixels
    const adjustedHeight = viewportHeight - headerFooterHeight // Adjusted height in pixels

    // Convert the adjusted height to 'vh' (Viewport Height) units
    const adjustedHeightVh = (adjustedHeight / viewportHeight) * 100
    this.scrollHeight = `${Math.round(adjustedHeightVh)}vh`
  }

  filterGlobal(event: any, dt: Table): void {
    this.isFilterApplied = !!event.target.value
    dt.filterGlobal(event.target.value, 'contains')
  }

  clear(table: Table) {
    this.isFilterApplied = false
    table.clearFilterValues()
    table.clear()
    // Clear the input field
    if (this.filterInput && this.filterInput.nativeElement) {
      this.filterInput.nativeElement.value = ''
    }
  }

  /**
   * This function receives a date and compares it with todays date.
   * It returns a boolean
   */
  getExpired(expiryDate: Date): boolean {
    if (!expiryDate) return undefined // If date isn't provided, consider it not expired for safety

    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const expiryDateComparison = new Date(expiryDate)
    expiryDateComparison.setHours(0, 0, 0, 0)

    return expiryDateComparison < today // Will return false if expiryDate is today or in the future
  }
}
